const careerForm = () => {
  const btn = document.querySelector(".creer-form-upload");
  const uploadInput = document.querySelector(".creer-form-upload input");
  const fileName = document.querySelector(".upload-file-name");
  if (!btn || !uploadInput) return;

  btn.addEventListener("click", () => {
    uploadInput.click();
  });

  // uploadInput.addEventListener("change", () => {
  //   fileName.innerHTML = uploadInput.files[0].name;
  // });

  const checkboxLabel = document.querySelector(".terms-label .wpcf7-list-item-label");
  const link = document.querySelector(".terms-link");
  checkboxLabel.innerHTML = "";
  checkboxLabel.insertAdjacentElement("beforeend", link);

  /* ugly fix :) */
  const setFileName = () => {
    if (uploadInput.files[0]) {
      fileName.innerHTML = uploadInput.files[0].name;
    } else {
      fileName.innerHTML = "";
    }
    requestAnimationFrame(setFileName);
  };

  setFileName();
};

export default careerForm;
